import React, { useEffect } from 'react'
import Footer from './components/Footer'

function Nei() {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://js-eu1.hsforms.net/forms/embed/147505908.js'
    script.defer = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <div>
      <div className='takk-heading'>
      </div>

      <div className='takk-body'>
        {/* HubSpot-form */}
        <div
          className="hs-form-frame"
          data-region="eu1"
          data-form-id="0aa002cc-0449-4bf2-ba54-52abd85aa7b0"
          data-portal-id="147505908"
        />
      </div>

      <Footer />
    </div>
  )
}

export default Nei
